import { MatchedProduct } from '../types/collection';
import { KafkaStyle } from '../types/kafkaEvent';

export function generateLayout(pageSize: number, productsLength: number, isMobile: boolean): string {
  let cols;
  let rows;

  if (isMobile) {
    cols = 2;
    rows = 2;
  } else {
    cols = 3;

    if (!pageSize) {
      rows = 2;
    } else {
      const maxRows = Math.ceil(productsLength / 3);

      rows = Math.min(maxRows, pageSize / 3, productsLength);
    }
  }

  return `${rows}*${cols}`;
}

// Generates style string from SKU
// 123-MUL-XL -> 123-MUL
export function generateStyleString(sku: string): string {
  const skuPartsArr = sku.split('-');

  return skuPartsArr[0] + '-' + skuPartsArr[1];
}

// Generates Size String from SKU
// 123-MUL-XL -> XL
export function generateSizeString(sku: string): string {
  const skuPartsArr = sku.split('-');

  return skuPartsArr[2];
}

export function generateStyleList(matchedProducts: MatchedProduct[]): KafkaStyle[] {
  let styleList = [];

  matchedProducts.forEach((matchedProduct: MatchedProduct) => {
    styleList.push({
      style: generateStyleString(matchedProduct.styleColors[0]),
      position: matchedProduct.position
    });
  });

  return styleList;
}

